import {
  Box,
  Typography,
  Paper,
  Divider,
  Select,
  Button,
  MenuItem,
  Menu,
  Grid,
  CircularProgress,
  TextareaAutosize,
} from "@mui/material";
import ImageZoomModal from "./ImageZoomModal";
import { styled } from "@mui/material/styles";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import Switch from "@mui/material/Switch";
import React, { useState, useEffect } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import ship1 from "../../../assets/images/ship1.png";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import ReactAudioPlayer from "react-audio-player";
import { useLocation } from "react-router-dom";
import { getDefectsDetailsList } from "../../../redux/actions/defectsAction";
import GenerateDefectId from "../../../utils/GenerateDefectId";
import jsPDF from "jspdf";
import ImageComponent from "./ImageComponent";
import attach from "../../../assets/images/attach.png";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import "jspdf-autotable";
import html2pdf from "html2pdf.js";

const ViewDefectDetailsContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const { DefectsRowData } = location?.state || {};

  const currentYear = new Date().getFullYear();

  const isLoading = useSelector((state) => state?.user?.isLoading);

  const defectstDetailsData = useSelector(
    (state) => state?.defects?.defectstDetailsData
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (image) => {
    if (image) {
      setSelectedImage(image);
      setIsModalOpen(true);
    }
  };

  const [defectsRowData, setDefectsRowData] = useState({});
  const [defectsDetailsData, setDefectsDetailsData] = useState({});
  const [showPreview, setShowPreview] = useState(() => {
    const storedValue = localStorage.getItem("showPreview");
    return storedValue ? JSON.parse(storedValue) : false;
  });

  useEffect(() => {
    localStorage.setItem("showPreview", JSON.stringify(showPreview));
  }, [showPreview]);

  const funcOnCLick = (x, y) => {
    setDefectsRowData(x);
    setDefectsDetailsData(y);
    localStorage.setItem("showPreview", "true");
    if (typeof window !== undefined) {
      window.location.reload();
    }
  };

  const BackDefects = () => {
    setShowPreview(false);
  };

  const createPDF = async () => {
    const pdf = new jsPDF("portrait", "pt", [595, 2000]);
    const data = await document.querySelector("#pdf");
    pdf.html(data, {margin:10,autoPaging:"text",}).then(() => {
      pdf.save("Defect Details.pdf");
    });
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  useEffect(() => {
    dispatch(
      getDefectsDetailsList({
        id: DefectsRowData,
      })
    );
  }, []);

  return (
    <>
      {showPreview ? (
        <Paper
          sx={{
            width: "auto",
            height: "820px",
            overflow: "auto",
            borderRadius: "10px",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box
            sx={{
              position: "sticky",
              backgroundColor: "#FFFFFF",
              top: "0",
              zIndex: "100",
            }}
          >
            <Box
              sx={{
                height: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "20px",
                overflow: "auto",
                width: "auto",
                overflowX: "auto",
                "&::-webkit-scrollbar": {
                  width: "5px",
                  height: "2px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#20724E",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#E5F1EB",
                },
                "@media (max-width: 768px)": {
                  width: "100%",
                },
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    display: "flex",
                    ml: 2,
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    BackDefects();
                  }}
                >
                  <img src={BackArrow} alt="" width="17" height="17" />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      ml: 1,
                      fontSize: "18px",
                      fontWeight: 600,
                      color: "#212121",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    PDF preview
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    mr: 2,
                  }}
                >
                  <Button
                    // variant="outlined"
                    sx={{
                      fontSize: "15px",
                      fontWeight: 600,
                      border: "1px solid #E5F1EB",
                      width: "9rem",
                      backgroundColor: "#E5F1EB",
                      padding: "8px 15px 5px 15px",
                      borderRadius: "10px",
                      textTransform: "capitalize",
                      color: "#20724E",
                      ":hover": {
                        backgroundColor: "#E5F1EB",
                        border: "1px solid #E5F1EB",
                      },
                    }}
                    onClick={() => createPDF()}
                  >
                    Download PDF
                  </Button>
                </Box>
              </Box>
            </Box>
            <Divider />
          </Box>

          <div
            id="pdf"
            style={{ width: "441.28pt", height: "auto", margin: "auto" }}
          >
            {" "}
            {/* A4 size */}
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "25px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "flex",
                  justifyContent: "center",
                  margin: "10px 0",
                }}
              >
                Defect Report
              </Typography>
              <Divider sx={{ width: "591px" }} />
              <Box>
                <Box sx={{ padding: "10px 25px 0px 25px" }}>
                  
                    <Grid
                      container
                      sx={{
                        bgcolor: "#F3F6F9",
                        marginBottom: "15px",
                        borderRadius: "10px",
                        padding: "10px 25px",
                      }}
                    >
                      <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                            flexDirection: "row",
                            "@media (max-width: 768px) ": {
                              flexDirection: "column",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              // backgroundColor: "#FFFFFF",
                              bgcolor: "#F3F6F9",
                              width: "100%",
                              padding: "10px",
                              borderRadius: "10px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                              }}
                            >
                              Defect ID :
                            </Typography>
                            <Typography
                              sx={{
                                marginLeft: "5px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {GenerateDefectId(
                                defectstDetailsData?.vessel?.name,
                                defectstDetailsData?.display_id
                              )}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                        <Box
                          sx={{
                            bgcolor: "#F3F6F9",
                            // backgroundColor: "#FFFFFF",
                            width: "100%",
                            padding: "10px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            Date :
                          </Typography>
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {moment(defectstDetailsData?.updatedAt).format(
                              "D MMMM, YYYY | hh:mm A"
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              // backgroundColor: "#FFFFFF",
                              bgcolor: "#F3F6F9",
                              width: "100%",
                              padding: "10px",
                              borderRadius: "10px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                              }}
                            >
                              Question :
                            </Typography>
                            <Typography
                              sx={{
                                marginLeft: "5px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {defectstDetailsData?.question?.question}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                            flexDirection: "row",
                            "@media (max-width: 768px) ": {
                              flexDirection: "column",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              // backgroundColor: "#FFFFFF",
                              bgcolor: "#F3F6F9",
                              width: "100%",
                              padding: "10px",
                              borderRadius: "10px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                              }}
                            >
                              Category of Defect:
                            </Typography>
                            <Typography
                              sx={{
                                marginLeft: "5px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {defectstDetailsData?.category_defetct}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                            flexDirection: "row",
                            "@media (max-width: 768px) ": {
                              flexDirection: "column",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              // backgroundColor: "#FFFFFF",
                              bgcolor: "#F3F6F9",
                              width: "100%",
                              padding: "10px",
                              borderRadius: "10px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                              }}
                            >
                              Vessel Name :
                            </Typography>
                            <Typography
                              sx={{
                                marginLeft: "5px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {defectstDetailsData?.vessel?.name}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                 
                    <Grid
                      container
                      sx={{
                        bgcolor: "#F3F6F9",
                        marginBottom: "20px",
                        borderRadius: "10px",
                        // display: "flex",
                        // justifyContent: "center",
                        // flexDirection: "row",
                        // "@media (max-width: 768px) ": {
                        //   flexDirection: "column",
                        // },
                      }}
                    >
                      <Grid item xs={12} sx={{ padding: "20px" }}>
                        <Box
                          sx={{
                            backgroundColor: "#FFFFFF",
                            height: "3.5rem",
                            // width: "100%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            Status :
                          </Typography>

                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {defectstDetailsData?.defect_report_status ===
                            "open"
                              ? "Open"
                              : "Closed"}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                            padding: "15px 10px 0px 10px",
                          }}
                        >
                          <Typography
                            sx={{
                              // marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            4. Fleet Director / Vessel Superintendent comments:
                          </Typography>
                        </Box>
                        <Box sx={{ marginTop: "10px" }}>
                          {defectstDetailsData?.line_manager_comment ? (
                            <Typography
                              sx={{
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "21px",
                                width: "100%",
                                borderRadius: "10px",
                                backgroundColor: "#FFFFFF",
                                border: "none",
                                padding: "15px",
                              }}
                            >
                              {defectstDetailsData?.line_manager_comment}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "21px",
                                width: "100%",
                                borderRadius: "10px",
                                backgroundColor: "#FFFFFF",
                                border: "none",
                                padding: "15px",
                                color: "#464E5F",
                              }}
                            >
                              Fleet Director comments is not available.
                            </Typography>
                          )}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                            padding: "15px 10px 0px 10px",
                          }}
                        >
                          <Typography
                            sx={{
                              // marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            5. Corrective / Preventive action Required:
                          </Typography>
                        </Box>
                        <Box sx={{ marginTop: "10px" }}>
                          {defectstDetailsData?.corrective_actions ? (
                            <Typography
                              sx={{
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "21px",
                                width: "100%",
                                borderRadius: "10px",
                                backgroundColor: "#FFFFFF",
                                border: "none",
                                padding: "15px",
                              }}
                            >
                              {defectstDetailsData?.corrective_actions}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "21px",
                                width: "100%",
                                borderRadius: "10px",
                                backgroundColor: "#FFFFFF",
                                border: "none",
                                padding: "15px",
                                color: "#464E5F",
                              }}
                            >
                              Corrective / Preventive action is not available.
                            </Typography>
                          )}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                            padding: "15px 10px 0px 10px",
                          }}
                        >
                          <Typography
                            sx={{
                              // marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            6. Follow-up and Close-out Inspection:
                          </Typography>
                        </Box>
                        <Box sx={{ marginTop: "10px" }}>
                          {defectstDetailsData?.followup_inspection ? (
                            <Typography
                              sx={{
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "21px",
                                width: "100%",
                                borderRadius: "10px",
                                backgroundColor: "#FFFFFF",
                                border: "none",
                                padding: "15px",
                              }}
                            >
                              {defectstDetailsData?.followup_inspection}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "21px",
                                width: "100%",
                                borderRadius: "10px",
                                backgroundColor: "#FFFFFF",
                                border: "none",
                                padding: "15px",
                                color: "#464E5F",
                              }}
                            >
                              Follow-up and Close-out Inspection is not
                              available.
                            </Typography>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                 
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        padding: "5px 10px 10px 10px",
                      }}
                    >
                      <Typography
                        sx={{
                          // marginLeft: "5px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        1. Description of Defective/Damaged Equipment or Plant:
                      </Typography>
                    </Box>
                    <Grid
                      container
                      sx={{
                        bgcolor: "#F3F6F9",
                        marginBottom: "20px",
                        borderRadius: "10px",
                        padding: "5px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            // backgroundColor: "#FFFFFF",
                            bgcolor: "#F3F6F9",
                            width: "100%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {defectstDetailsData?.description}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        padding: "5px 10px 10px 10px",
                      }}
                    >
                      <Typography
                        sx={{
                          // marginLeft: "5px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        2. Cause:
                      </Typography>
                    </Box>
                    <Grid
                      container
                      sx={{
                        bgcolor: "#F3F6F9",
                        borderRadius: "10px",
                        padding: "5px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            // backgroundColor: "#FFFFFF",
                            bgcolor: "#F3F6F9",
                            width: "100%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            fullWidth
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {defectstDetailsData?.cause}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>

                    <Box sx={{ marginBottom: "20px", marginTop: "15px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "left",
                          padding: "5px 10px 10px 10px",
                        }}
                      >
                        <Typography
                          sx={{
                            // marginLeft: "5px",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          3. Immediate Correction:
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            bgcolor: "#F3F6F9",
                            width: "100%",
                            padding: "13px",
                            borderRadius: "10px",
                          }}
                        >
                          <Box sx={{ margin: "10px 0" }}>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                              }}
                            >
                              {" "}
                              1. What correctional activity to repair the defect
                              has been carried out by the vessel’s staff?
                            </Typography>
                            {/* <div style={{ padding: "10px", position: "relative", left: "12px", fontSize: "14px", fontWeight: "400" }}> */}
                            <div
                              style={{ fontSize: "14px", fontWeight: "400" }}
                            >
                              {defectstDetailsData?.immediate_correction_qa_one}
                            </div>
                            {/* </div> */}
                          </Box>
                          <Divider />
                          <Box sx={{ margin: "10px 0" }}>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                              }}
                            >
                              {" "}
                              2. What is the scope of assistance required from
                              shore maintenance staff, including spares (if
                              any)?{" "}
                            </Typography>
                            <Typography
                              sx={{ fontSize: "14px", fontWeight: "400" }}
                            >
                              <div>
                                {
                                  defectstDetailsData?.immediate_correction_qa_two
                                }
                              </div>
                            </Typography>
                          </Box>
                          <Divider />
                          <Box sx={{ margin: "10px 0" }}>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                              }}
                            >
                              {" "}
                              3.What requisition(s) have been submitted relating
                              to this defect (nos/dates)?{" "}
                            </Typography>
                            <Typography
                              sx={{ fontSize: "14px", fontWeight: "400" }}
                            >
                              {
                                defectstDetailsData?.immediate_correction_qa_three
                              }
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <Box sx={{ marginBottom: "20px" }}>
                        {defectstDetailsData?.defect?.file.length !== 0 ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "10px",
                              flexDirection: "row",
                            }}
                            style={{ marginBottom: "20px" }}
                          >
                            <Box
                              sx={{
                                backgroundColor: "#F3F6F9",
                                width: "100%",
                                padding: "13px",
                                borderRadius: "10px",
                                display: "flex",
                                flexDirection: "column",
                                overflowX: "auto",
                                "&::-webkit-scrollbar": {
                                  width: "5px",
                                  height: "2px",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor: "#20724E",
                                  borderRadius: "4px",
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor: "#E5F1EB",
                                },
                                "@media (max-width: 768px)": {
                                  width: "100%",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  lineHeight: "21px",
                                }}
                              >
                                Attachment by Vessel
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "10px",
                                  padding: "5px 5px 5px 5px",
                                }}
                              >
                                {defectstDetailsData?.defect?.file?.map(
                                  (image, index) =>
                                    image?.contentType !== "application/pdf" ? (
                                      <ImageComponent
                                        key={index}
                                        imageUrl={image?.URL}
                                      />
                                    ) : (
                                      <Box
                                        key={index}
                                        sx={{
                                          position: "relative",
                                          overflow: "hidden",
                                          borderRadius: "10px",
                                        }}
                                      >
                                        <a
                                          href={image?.URL}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "70px",
                                            height: "70px",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <PictureAsPdfIcon />
                                        </a>
                                      </Box>
                                    )
                                )}
                              </Box>
                            </Box>
                          </Box>
                        ) : (
                          <Box sx={{ marginBottom: "10px" }}></Box>
                        )}
                      </Box>
                      <Box
                        sx={{ marginBottom: "20px", breakBefore: "always" }}
                        id="img"
                      >
                        {defectstDetailsData?.line_manager_attachment?.length >
                        0 ? (
                          <Box sx={{ display: "flex" }}>
                            <Box
                              sx={{
                                backgroundColor: "#F3F6F9",
                                width: "100%",
                                padding: "13px",
                                borderRadius: "10px",
                                display: "flex",
                                flexDirection: "column",
                                overflowX: "auto",
                                whiteSpace: "nowrap",
                                "&::-webkit-scrollbar": {
                                  width: "5px",
                                  height: "2px",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor: "#20724E",
                                  borderRadius: "4px",
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor: "#E5F1EB",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  lineHeight: "21px",
                                }}
                              >
                                Attachment by Line Manager
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "10px",
                                  padding: "5px 5px 5px 5px",
                                }}
                              >
                                {defectstDetailsData?.line_manager_attachment?.map(
                                  (e, i) => (
                                    <Box
                                      component="div"
                                      key={i}
                                      sx={{
                                        position: "relative",
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        overflow: "hidden",
                                        borderRadius: "0px",
                                        display: "flex",
                                        marginTop: "5px",
                                      }}
                                    >
                                      <img
                                        src={attach}
                                        alt={`Selected Image ${i + 1}`}
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                          objectFit: "cover",
                                          marginTop: "2px",
                                        }}
                                      />
                                      <Typography
                                        sx={{
                                          fontWeight: "400",
                                          fontSize: "14px",
                                          lineHeight: "21px",
                                          padding: "0 0 0 10px",
                                        }}
                                      >
                                        {`Attachment Image ${i + 1}`}
                                      </Typography>
                                    </Box>
                                  )
                                )}
                              </Box>
                            </Box>
                          </Box>
                        ) : null}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            
          </div>
        </Paper>
      ) : (
        <>
          <Paper
            sx={{
              width: "auto",
              height: "820px",
              overflow: "auto",
              borderRadius: "10px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            <Box
              sx={{
                position: "sticky",
                backgroundColor: "#FFFFFF",
                top: "0",
                zIndex: "100",
              }}
            >
              <Box
                sx={{
                  padding: "0 10px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "20px",
                  overflow: "auto",
                  width: "auto",
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    width: "5px",
                    height: "2px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#20724E",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#E5F1EB",
                  },
                  "@media (max-width: 768px)": {
                    width: "100%",
                  },
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        ml: 2,
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        navigate("/defects");
                      }}
                    >
                      <img src={BackArrow} alt="" width="17" height="17" />
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          ml: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "#212121",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Defect Details
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ display: "flex" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      mr: 2,
                    }}
                  >
                    <Button
                      // variant="outlined"
                      sx={{
                        fontSize: "15px",
                        fontWeight: 600,
                        border: "1px solid #E5F1EB",
                        width: "9rem",
                        backgroundColor: "#E5F1EB",
                        padding: "8px 15px 5px 15px",
                        borderRadius: "10px",
                        textTransform: "capitalize",
                        color: "#20724E",
                        ":hover": {
                          backgroundColor: "#E5F1EB",
                          border: "1px solid #E5F1EB",
                        },
                      }}
                      onClick={() => funcOnCLick()}
                    >
                      Export as PDF
                    </Button>
                  </Box>
                </Box>
              </Box>
              <Divider />
            </Box>
            {isLoading ? (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "auto",
                  height: "70%",
                }}
              >
                <CircularProgress color="success" />
              </Box>
            ) : (
              <Box>
                <Box sx={{ padding: "25px 25px 25px 25px" }}>
                  <Grid
                    container
                    sx={{
                      bgcolor: "#F3F6F9",
                      marginBottom: "20px",
                      borderRadius: "10px",
                      padding: "25px 25px 25px 25px",
                    }}
                  >
                    <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                          flexDirection: "row",
                          "@media (max-width: 768px) ": {
                            flexDirection: "column",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            // backgroundColor: "#FFFFFF",
                            bgcolor: "#F3F6F9",
                            width: "100%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            Defect ID :
                          </Typography>
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {GenerateDefectId(
                              defectstDetailsData?.vessel?.name,
                              defectstDetailsData?.display_id
                            )}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            bgcolor: "#F3F6F9",
                            // backgroundColor: "#FFFFFF",
                            width: "100%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            Date :
                          </Typography>
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {moment(defectstDetailsData?.updatedAt).format(
                              "D MMMM, YYYY | hh:mm A"
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                          flexDirection: "row",
                          "@media (max-width: 768px) ": {
                            flexDirection: "column",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            // backgroundColor: "#FFFFFF",
                            bgcolor: "#F3F6F9",
                            width: "100%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            Question :
                          </Typography>
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {defectstDetailsData?.question?.question}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            bgcolor: "#F3F6F9",
                            // backgroundColor: "#FFFFFF",
                            width: "100%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            Category of Defect:
                          </Typography>
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {defectstDetailsData?.category_defetct}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                          flexDirection: "row",
                          "@media (max-width: 768px) ": {
                            flexDirection: "column",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            // backgroundColor: "#FFFFFF",
                            bgcolor: "#F3F6F9",
                            width: "100%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            Vessel Name :
                          </Typography>
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {defectstDetailsData?.vessel?.name}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={{
                      bgcolor: "#E5F1EB",
                      marginBottom: "20px",
                      borderRadius: "10px",
                      // display: "flex",
                      // justifyContent: "center",
                      // flexDirection: "row",
                      // "@media (max-width: 768px) ": {
                      //   flexDirection: "column",
                      // },
                    }}
                  >
                    <Grid item xs={6} sx={{ padding: "25px 25px 25px 25px" }}>
                      <Box
                        sx={{
                          backgroundColor: "#FFFFFF",
                          height: "3.5rem",
                          // width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: "15px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                            color: "#20724E",
                          }}
                        >
                          Status:
                        </Typography>
                        <Typography
                          sx={{
                            marginLeft: "5px",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {defectstDetailsData?.defect_report_status === "open"
                            ? "Open"
                            : "Closed"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "left",
                          padding: "0px 10px 10px 10px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                            color: "#20724E",
                          }}
                        >
                          4. Fleet Director / Vessel Superintendent comments:
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          backgroundColor: "#FFFFFF",
                          // height: "4.5rem",
                          height: "auto",
                          // width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: "15px",
                        }}
                      >
                        {defectstDetailsData?.line_manager_comment ? (
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                              // lineHeight: "1.5",
                            }}
                          >
                            {defectstDetailsData?.line_manager_comment}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              fontSize: "14px",
                              padding: "10px 10px 10px 0",
                              color: "#464E5F",
                              opacity: "0.6",
                              // lineHeight: "1.5",
                            }}
                          >
                            Fleet Director comments is not available.
                          </Typography>
                        )}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "left",
                          padding: "0px 10px 10px 10px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                            color: "#20724E",
                          }}
                        >
                          5. Corrective / Preventive action Required:
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          backgroundColor: "#FFFFFF",
                          height: "auto",
                          // width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        {defectstDetailsData?.corrective_actions ? (
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {defectstDetailsData?.corrective_actions}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              fontSize: "14px",
                              padding: "10px 10px 10px 0",
                              color: "#464E5F",
                              opacity: "0.6",
                            }}
                          >
                            Corrective / Preventive action is not available.
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={6} sx={{ padding: "25px 25px 25px 25px" }}>
                      <Box
                        sx={{
                          backgroundColor: "#FFFFFF",
                          marginBottom: "15px",
                          // width: "50%",
                          padding: "26px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "column",
                          overflowX: "auto",
                          whiteSpace: "nowrap",
                          "&::-webkit-scrollbar": {
                            width: "5px",
                            height: "2px",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#20724E",
                            borderRadius: "4px",
                          },
                          "&::-webkit-scrollbar-track": {
                            backgroundColor: "#E5F1EB",
                          },
                          "@media (max-width: 768px)": {
                            width: "100%",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                            color: "#20724E",
                          }}
                        >
                          Attachment by Line Manager
                        </Typography>
                        {defectstDetailsData?.line_manager_attachment ===
                          null ||
                        defectstDetailsData?.line_manager_attachment?.length ===
                          0 ? (
                          <Typography
                            sx={{
                              color: "#464E5F",
                              fontSize: "14px",
                              padding: "10px 10px 10px 0",
                              opacity: "0.6",
                            }}
                          >
                            Attachment is not available
                          </Typography>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              gap: "10px",
                              padding: "5px 5px 5px 5px",
                            }}
                          >
                            {defectstDetailsData?.line_manager_attachment?.map(
                              (image, index) => {
                                return image?.contentType !==
                                  "application/pdf" ? (
                                  <Box
                                    key={index}
                                    component="img"
                                    sx={{
                                      height: 70,
                                      width: 70,
                                      borderRadius: "10px",
                                      maxHeight: { xs: 233, md: 167 },
                                      maxWidth: { xs: 350, md: 250 },
                                    }}
                                    alt="Attachment is not available"
                                    src={image?.URL}
                                    onClick={() => openModal(image?.URL)}
                                  />
                                ) : (
                                  <Box
                                    key={index}
                                    sx={{
                                      position: "relative",
                                      overflow: "hidden",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <a
                                      href={image?.URL}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "70px",
                                        height: "70px",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      <PictureAsPdfIcon />
                                    </a>
                                  </Box>
                                );
                              }
                            )}
                          </Box>
                        )}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "left",
                          padding: "0px 10px 10px 10px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                            color: "#20724E",
                          }}
                        >
                          6. Follow-up and Close-out Inspection:
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          backgroundColor: "#FFFFFF",
                          height: "auto",
                          // width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        {defectstDetailsData?.followup_inspection ? (
                          <Typography
                            sx={{
                              marginLeft: "5px",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {defectstDetailsData?.followup_inspection}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              fontSize: "14px",
                              padding: "10px 10px 10px 0",
                              color: "#464E5F",
                              opacity: "0.6",
                            }}
                          >
                            Follow-up and Close-out Inspection is not available.
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      padding: "5px 10px 10px 10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "14px",
                        lineHeight: "21px",
                        color: "#20724E",
                      }}
                    >
                      1. Description of Defective/Damaged Equipment or Plant:
                    </Typography>
                  </Box>
                  <Grid
                    container
                    sx={{
                      bgcolor: "#F3F6F9",
                      marginBottom: "20px",
                      borderRadius: "10px",
                      padding: "25px 25px 25px 25px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#FFFFFF",
                          // bgcolor: "#F3F6F9",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Typography
                          sx={{
                            marginLeft: "5px",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {defectstDetailsData?.description}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      padding: "5px 10px 10px 10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      2. Cause:
                    </Typography>
                  </Box>
                  <Grid
                    container
                    sx={{
                      bgcolor: "#F3F6F9",
                      marginBottom: "20px",
                      borderRadius: "10px",
                      padding: "25px 25px 25px 25px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#FFFFFF",
                          // bgcolor: "#F3F6F9",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        {/* <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Cause :
                        </Typography> */}
                        <Typography
                          fullWidth
                          sx={{
                            marginLeft: "5px",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {defectstDetailsData?.cause}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      padding: "5px 10px 10px 10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      3. Immediate Correction:
                    </Typography>
                  </Box>
                  <Grid
                    container
                    sx={{
                      bgcolor: "#F3F6F9",
                      marginBottom: "20px",
                      borderRadius: "10px",
                      padding: "25px 25px 25px 25px",
                    }}
                  >
                    <Grid item xs={12} sx={{ marginBottom: "20px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#F3F6F9",
                            width: "100%",
                            padding: "15px",
                            borderRadius: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              margin: "10px 0",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                                color: "#20724E",
                              }}
                            >
                              1. What correctional activity to repair the defect
                              has been carried out by the vessel’s staff?
                            </Typography>
                            <Typography
                              sx={{
                                bgcolor: "#FFFFFF",
                                borderRadius: "10px",
                                padding: "10px",
                                position: "relative",
                                left: "12px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {defectstDetailsData?.immediate_correction_qa_one}
                            </Typography>
                          </Box>
                          <Divider />
                          <Box sx={{ margin: "10px 0" }}>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                                color: "#20724E",
                              }}
                            >
                              2. What is the scope of assistance required from
                              shore maintenance staff, including spares (if
                              any)?
                            </Typography>
                            <Typography
                              sx={{
                                bgcolor: "#FFFFFF",
                                borderRadius: "10px",
                                padding: "10px",
                                position: "relative",
                                left: "12px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {defectstDetailsData?.immediate_correction_qa_two}
                            </Typography>
                          </Box>
                          <Divider />
                          <Box sx={{ margin: "10px 0" }}>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "21px",
                                color: "#20724E",
                              }}
                            >
                              3.What requisition(s) have been submitted relating
                              to this defect (nos/dates)?
                            </Typography>
                            <Typography
                              sx={{
                                bgcolor: "#FFFFFF",
                                borderRadius: "10px",
                                padding: "10px",
                                position: "relative",
                                left: "12px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {
                                defectstDetailsData?.immediate_correction_qa_three
                              }
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={{
                      bgcolor: "#F3F6F9",
                      marginBottom: "20px",
                      borderRadius: "10px",
                      padding: "25px 25px 25px 25px",
                    }}
                  >
                    <Grid item xs={12} sx={{ marginBottom: "20px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                          flexDirection: "row",
                          "@media (max-width: 768px) ": {
                            flexDirection: "column",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            // backgroundColor: "#FFFFFF",
                            bgcolor: "#F3F6F9",
                            width: "50%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "column",
                            // alignItems: "center",
                            "@media (max-width: 768px)": {
                              width: "100%",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            Voice Message
                          </Typography>
                          {defectstDetailsData?.defect?.audio_file !== null ? (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                alignItem: "left",
                                padding: "10px",
                              }}
                            >
                              <ReactAudioPlayer
                                src={
                                  defectstDetailsData?.defect?.audio_file
                                    ? defectstDetailsData?.defect?.audio_file
                                    : "Audio file is not available"
                                } // Replace with your audio file URL
                                controls
                              />
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                color: "#464E5F",
                                fontSize: "14px",
                                padding: "10px 10px 10px 0",
                                opacity: "0.6",
                              }}
                            >
                              Audio is not available{" "}
                            </Box>
                          )}
                        </Box>
                        <Box
                          sx={{
                            bgcolor: "#F3F6F9",
                            // backgroundColor: "#FFFFFF",
                            width: "50%",
                            padding: "15px",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "column",
                            overflowX: "auto",
                            "&::-webkit-scrollbar": {
                              width: "5px",
                              height: "2px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              backgroundColor: "#20724E",
                              borderRadius: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              backgroundColor: "#E5F1EB",
                            },
                            "@media (max-width: 768px)": {
                              width: "100%",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            Attachment by Vessel
                          </Typography>
                          {defectstDetailsData?.defect?.file.length !== 0 ? (
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                padding: "5px 5px 5px 5px",
                              }}
                            >
                              {defectstDetailsData?.defect?.file?.map(
                                (image, index) =>
                                  image?.contentType !== "application/pdf" ? (
                                    <Box
                                      key={index}
                                      component="img"
                                      sx={{
                                        height: 70,
                                        width: 70,
                                        borderRadius: "10px",
                                        maxHeight: { xs: 233, md: 167 },
                                        maxWidth: { xs: 350, md: 250 },
                                      }}
                                      // alt="Attachment is not available"
                                      src={image?.URL}
                                      onClick={() => openModal(image?.URL)}
                                    />
                                  ) : (
                                    <Box
                                      key={index}
                                      sx={{
                                        position: "relative",
                                        overflow: "hidden",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      <a
                                        href={image?.URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "70px",
                                          height: "70px",
                                          borderRadius: "10px",
                                        }}
                                      >
                                        <PictureAsPdfIcon />
                                      </a>
                                    </Box>
                                  )
                              )}
                            </Box>
                          ) : (
                            <Typography
                              sx={{
                                color: "#464E5F",
                                fontSize: "14px",
                                padding: "10px 10px 10px 0",
                                opacity: "0.6",
                              }}
                            >
                              Attachment is not available{" "}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}
          </Paper>
          <ImageZoomModal
            sx={{
              width: "50%",
              height: "100%",
              objectfit: "contain",
            }}
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            src={selectedImage}
            alt="Attachment is not available"
          />
        </>
      )}
    </>
  );
};

export default ViewDefectDetailsContent;
